/* istanbul ignore file */
/* ported from compwnents */
export const defaultProps = {
  /**
   * The base URL for the Thumbor service. Default `https://images.havenly.com`.
   */
  server: 'https://images.havenly.com/unsafe' as string,

  /**
   * The src URL for the image.
   */
  src: '' as string,

  /**
   * The default srcset array
   */
  srcSet: [2],

  /**
   * Apply filters
   */
  filters: {},
};

export interface IProps extends Partial<typeof defaultProps> {
  /**
   * The value attribute for this element.
   */
  server?: string;

  /**
   * The src URL for the image.
   */
  src: string;

  /**
   * The width of the image.
   */
  width?: string | number;

  /**
   * The height of the image.
   */
  height?: string | number;

  /**
   * Array of resolution sizes to be applied to srcSet. Default `[2]`.
   */
  srcSet?: number[];

  /**
   * Apply filters
   */
  filters?: { [key: string]: any };

  /**
   * Class name applied to img
   */
  className?: string;

  /**
   * Style object applied to img
   */
  style?: object;

  /**
   * Img alt attribute
   */
  alt?: string;

  /**
   * Img id
   */
  id?: string | undefined;

  /**
   * Apply fit-in
   */
  trim?: boolean | 'top-left' | 'bottom-right';

  /**
   * Apply fit-in
   */
  fitIn?: boolean;

  /**
   * HMAC security token
   */
  hmac?: string;

  onLoad?: () => void;

  loadEagerly?: boolean;

  nextImage?: boolean;

  priority?: boolean;

  sizes?: string;

  quality?: number;
}

export default defaultProps;
